export default __webpack_public_path__ + "static/media/download_disabled.e59d328a.svg";